import apiClient from './client';

// Portal usage analytics (staff-only, CR #175). Admin previews are excluded
// server-side, so these numbers are real portal traffic only.

export interface PortalUsageSummary {
  linked: boolean;
  userId: number | null;
  lastLogin: string | null;
  logins: { d7: number; d30: number; total: number };
  topPaths: { path: string; count: number }[];
  daily: { day: string; count: number }[];
}

export const getEmployeePortalUsage = async (employeeId: number): Promise<PortalUsageSummary> => {
  const { data } = await apiClient.get(`/portal-usage/employee/${employeeId}`);
  return data.data;
};

export const getClientPortalUsage = async (clientId: number): Promise<PortalUsageSummary> => {
  const { data } = await apiClient.get(`/portal-usage/client/${clientId}`);
  return data.data;
};
